import React from "react";
import styles from "./Textarea.module.css";

const Textarea = ({
  label,
  name,
  register,
  errors,
  validation = {},
  placeholder = "",
  rows = 4,
  mandate = false,
  disabled = false,
}) => (
  <div className={styles.wrapper}>
    <fieldset
      className={`${styles.fieldset}  ${disabled ? styles.disabled : ""} ${
        errors?.[name] ? styles.error : ""
      }`}
    >
      <legend className={styles.legend}>
        {label}
        {mandate && <span className={styles.mandate}> *</span>}
      </legend>

      <textarea
        rows={rows}
        placeholder={placeholder}
        {...register(name, validation)}
        className={styles.textarea}
        disabled={disabled}
      />
    </fieldset>

    {errors?.[name] && (
      <p className={styles.errorText}>{errors[name].message}</p>
    )}
  </div>
);

export default Textarea;
